import { render, staticRenderFns } from "./JLocation.vue?vue&type=template&id=390a2ed5"
import script from "./JLocation.vue?vue&type=script&lang=js"
export * from "./JLocation.vue?vue&type=script&lang=js"
import style0 from "./JLocation.vue?vue&type=style&index=0&id=390a2ed5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports